import { providersOnHome } from '../../store/newCasinoHome/casinoHome.thunks'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

export const connectNewCasinoHome = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      providersOnHome: state.casinoHome.providersOnHome,
      providerWiseData: state.casinoHome.providerWiseData,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      providersOnHome,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
